import styled, { css } from "styled-components";
import { mobile } from "../../utils/css/media";
import ButtonSmall from "../common/ButtonSmall";
import { headerHeight, footerHeight } from "../../utils/css/sizes";
import { h4, h6 } from "../../utils/css/typography";

const ButtonSmallWider = styled(ButtonSmall)`
  margin: 15px 10px;
  min-width: 115px;
`;

const DivCenter = styled.div`
  height: calc(100vh - ${headerHeight}px - ${footerHeight}px);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  ${mobile(css`
    height: 73vh;
  `)}
`;

const CloudOne = styled.img`
  position: absolute;
  top: 28%;
  left: 60%;

  ${mobile(css`
    top: 25%;
    left: 72%;
  `)}
`;

const CloudTwo = styled.img`
  position: absolute;
  top: 34%;
  left: 25%;
  width: 72px;

  ${mobile(css`
    top: 29%;
    left: 5%;
  `)}
`;

const CloudThree = styled.img`
  position: absolute;
  top: 18%;
  left: 75%;
  width: 69px;

  ${mobile(css`
    top: 15%;
    left: 40%;
  `)}
`;

const CanoImg = styled.img`
  width: 17%;
  ${mobile(css`
    width: 58%;
  `)}
`;

const NotFoundText = styled.div`
  ${h4}
  margin-bottom: 1.5%;

  ${mobile(css`
    ${h6}
  `)}
`;

export {
  ButtonSmallWider,
  DivCenter,
  CanoImg,
  NotFoundText,
  CloudOne,
  CloudTwo,
  CloudThree,
};
